export default __webpack_public_path__ + "static/med-board-685f2a53c641632b8b79b9009266175e.png";